export const Namespace = 'GLOBAL';
export enum AppAction {
    Rename = 'RENAME', 
    Download = 'DOWNLOAD', 
    Delete = 'DELETE', 
    Move = 'MOVE',
    Copy = 'COPY',
    EditInShareBaseDesktop = 'EDIT_IN_SHAREBASE_DESKTOP',
    EditInOfficeOnline = 'EDIT_IN_OFFICE_ONLINE',
    SortChange = 'SORT_CHANGE',
    CreateDocumentLinkShare = 'CREATE_DOCUMENT_SHARE_LINK',
    CreateDocumentUserShare = 'CREATE_DOCUMENT_SHARE_USER',
    CreateFolderLinkShare = 'CREATE_FOLDER_SHARE_LINK',
    CreateFolderUserShare = 'CREATE_FOLDER_SHARE_USER',
    Replace = 'REPLACE',
    Favorite = 'FAVORITE',
    Unfavorite = 'UNFAVORITE',
    RefreshSelectionBar = 'REFRESH_SELECTION_BAR',
    OpenInNew = 'OPEN_IN_NEW',
    CreateTask = 'CREATE_TASK',
    DragToMove = 'DRAG_TO_MOVE',
    EndDrag = 'END_DRAG',
    PromptForDesktopInstall = 'PROMPT_FOR_DESKTOP_INSTALL'
};



// WEBPACK FOOTER //
// ./src/sharebase-app/components/_app/app.actions.ts